import React, { FC, useState, useEffect, useContext } from 'react'
import { usePromiseTracker, trackPromise } from 'react-promise-tracker'
import { isMobile } from 'react-device-detect'
import _ from 'lodash'

import history from '../../../history'
import AppContext from '../../../context/appContext'
import { getFolders, getUserData } from '../../../Api/backendApi'

import NavigationBar from '../../NavigationBar/NavigationBar'
import GenericBackgroundLayer from '../../../GenericComponents/GenericBackgroundLayer'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericColumn from '../../../GenericComponents/GenericColumn'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import MainpageCarousel from '../../MainScreen/views/MainpageCarousel'
import { albumType } from '../../../utils/albumCategories'

interface ChooseFolderViewProps {
  selectMiazga: Function
}

const ChooseFolderView: FC<ChooseFolderViewProps> = ({ selectMiazga }) => {
  const appContext = useContext(AppContext)
  const { promiseInProgress } = usePromiseTracker()

  const [folders, setFolders] = useState()
  const [user, setUser] = useState(Object)

  useEffect(() => {
    obtainUser()
    obtainFolders()
  }, [])

  const obtainUser = async () => {
    if (appContext.appState.user) {
      setUser(appContext.appState.user)
    }

    const user = await trackPromise(getUserData())
    setUser(user)
    appContext.updateAppState('user', user)
  }

  const obtainFolders = async () => {
    if (appContext.appState.albums) {
      setFolders(appContext.appState.albums)
    }

    let folders = await trackPromise(getFolders())
    setFolders(folders)
    appContext.updateAppState('albums', folders)
  }

  return (
    <GenericBackgroundLayer
      justify={'flex-start'}
      className={`${
        appContext.appState.theme == 'light' ? 'light' : 'standard'
      } mainpage`}
    >
      <NavigationBar
        isPlayerView={false}
        backButtonAction={() => history.push('/trening')}
      />

      <GenericRow
        padding={isMobile ? '10px' : 'unset'}
        wrap={isMobile ? 'wrap' : 'unset'}
        margin={'1% auto'}
        width={isMobile ? '100%' : '60%'}
        justify={'flex-start'}
      >
        <GenericColumn width={isMobile ? '100%' : '30%'}>
          <GenericRow justify={'flex-start'}>
            <GenericTextSpan
              fSize={'2rem'}
              margin={'5vh 0 1% 0%'}
              tAlign={'left'}
              display={'block'}
              className={`${
                appContext.appState.theme == 'light' ? 'light' : ''
              }`}
            >
              Cześć {user && user.name}
            </GenericTextSpan>
          </GenericRow>
          <GenericRow justify={'flex-start'}>
            <GenericTextSpan
              opacity={'0.7'}
              display={'block'}
              margin={'2% 0 1% 0%'}
              className={`${
                appContext.appState.theme == 'light' ? 'light' : ''
              }`}
            >
              Super, że jesteś
            </GenericTextSpan>
          </GenericRow>
        </GenericColumn>
      </GenericRow>

      <GenericRow margin={'3vh 0 0 0'}>
        <GenericTextSpan fSize={'1.1rem'}>
          Wybierz dział miazga który chcesz zrobić wpólnie
        </GenericTextSpan>
      </GenericRow>

      <GenericRow margin={'6vh 0 0 0'}>
        <MainpageCarousel
          conferencesTrainings={false}
          fullWidth={false}
          onClick={selectMiazga}
          isConferences={true}
          // ref={carousel6Ref}
          isDemoMode={false}
          folders={folders && folders}
          albumType={albumType.treningiMiazga.name}
          albumName={albumType.treningiMiazga.label}
          categoryTag={albumType.treningiMiazga.tag}
          setDemoUserRedirectToSubModalOpen={null}
        ></MainpageCarousel>
      </GenericRow>
    </GenericBackgroundLayer>
  )
}

export default ChooseFolderView
